<template>
    <div id="modalCreditsCards" class="modal modal-block-outside modal-pdv" @keydown.esc="closeModalCreditsCards()">
        <div class="modal-header">
            <div class="image-title">
                <h2>Número de tarjeta y código</h2>
            </div>
            <div class="btnClose">
                <a href="#!" @click="closeModalCreditsCards()"
                    class="modal-action modal-close waves-effect waves-green btn-flat">
                    <span class="icon-Bistro-_Close"></span>
                </a>
            </div>
        </div>

        <div class="modal-body">
            <section v-if="!selectedCard" class="box-credits-cards">
                <h4>1. Seleccione la tarjeta</h4>
                <div>
                    <ButtonPayCard :variant="'icon-only'" :icon="require('@/features/pdv/assets/img/visa-credito.svg')"
                         @handleClick="selectMethod('visa-credito')" :alt="'visa-credito'" /> <!-- assets/img/credit_cards/tc_visa.png -->
                    <ButtonPayCard :variant="'icon-only'" :icon="require('@/features/pdv/assets/img/amex.svg')"
                        @handleClick="selectMethod('amex')" :alt="'amex'" />
                    <ButtonPayCard v-show="hasToShowCabal" :variant="'icon-only'" :icon="require('@/features/pdv/assets/img/cabal.svg')"
                        @handleClick="selectMethod('cabal')" :alt="'cabal'" />
                    <ButtonPayCard v-show="hasToShowMaestro" :variant="'icon-only'" :icon="require('@/features/pdv/assets/img/maestro.svg')"
                        @handleClick="selectMethod('maestro')" :alt="'maestro'" />
                    <ButtonPayCard :variant="'icon-only'"
                        :icon="require('@/features/pdv/assets/img/mastercard.svg')"
                        @handleClick="selectMethod('mastercard')" :alt="'mastercard'" />
                    <ButtonPayCard :variant="'icon-only'"
                        :icon="require('@/features/pdv/assets/img/visa-debito.svg')"
                        @handleClick="selectMethod('visa-debito')" :alt="'visa-debito'" />
                </div>
            </section>
            <section class="box-credits-cards" v-else>

                <h4>2. Código de autorización</h4>
                <div>
                    <ButtonPayCard :variant="'icon-only'" :icon="getCardIcon(selectedCard)" :disableHover="true"/>
                    <label>
                        <input type="text"  maxlength="6" placeholder="Ingrese código de autorización" v-model="authCode" @input="clearInput" @keydown="handleKeydown"/>
                    </label>
                </div>
            </section>
        </div>
        <hr>
        <div class="modal-footer">
            <ButtonModals text="Cancelar" variant="return btn-modal" @handleClick="closeModalCreditsCards" />
            <ButtonModals v-show="selectedCard" text="Confirmar pago" variant="main btn-modal"  @handleClick="confirmAuthCode" />
        </div>
    </div>
</template>

<script>
import ButtonModals from "@/features/shared/components/ButtonModals.vue"
import mixModals from '@/mixins/mixModals.vue';
import payCommons from '../../mixins/payCommons.vue';
import ButtonPayCard from '../ButtonPayCard.vue';
import instanceCommons from "@/mixins/instanceCommons.vue";

export default {
    mixins: [payCommons, mixModals, instanceCommons],
    data() {
        return {
            authCode: null,
            selectedCard: null
        };
    },
    methods: {
        clearInput(event) {
            // Filter out non-numeric characters
            const value = event.target.value.replace(/[^0-9]/g, "");
            this.authCode = value;
        },
        handleKeydown(event) {
            // Stop propagation for backspace and delete keys to prevent modal interference
            if (event.key === 'Backspace' || event.key === 'Delete') {
                event.stopPropagation();
            }
        },
        confirmAuthCode() {
            this.$emit("onCardSelected", {
                selectedCard: this.selectedCard,
                authCode: this.authCode
            });
            this.closeModalById('#modalCreditsCards')
        },
        selectMethod(method) {
            this.selectedCard = method;
        },
        getCardIcon(card) {
            return require(`@/features/pdv/assets/img/${card}.svg`);
        },
    },
    computed:{
        hasToShowCabal() {
            switch (this.isMexicoInstance) {
                case true:
                    return false;
                default:
                    return true;
            }
        },
        hasToShowMaestro(){
            switch (this.isMexicoInstance) {
                case true:
                    return false;
                default:
                    return true;
            }

        }
    },
    components: {
        ButtonModals,
        ButtonPayCard
    }
}
</script>

<style lang="scss" scoped>
.box-credits-cards {
    padding: 40px;

    h4{
        padding-bottom: 10px;
    }

    &>div {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
    }

    .button-pay .button-icon-pay img {
        width: 80px;
    }
}

.modal-footer{
    display: flex;
    justify-content: flex-end;
    &>button {
    margin-right: 20px;
    
}
}
</style>
